/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef, useState } from 'react';
import { IHouseType } from '@/redux/store/reducer/homeReducer';
import HouseTypeMobile from './houseTypeMobile/HouseTypeMobile';
import useSearchParams from '@/components/search/hooks/useSearchParams';
import useDevice from '@/hooks/useDevice';
import FilterChips from '../reusabe/filterChips/FilterChips';
import Drawer from '@/components/UI/drawer/Drawer';
import useDrawer from '@/hooks/useDrawer';
import styles from './HouseType.module.scss';
import Box from '@/components/UI/box/Box';
import Menu from '@/components/UI/menu/Menu';
export type IOption = {
  name: IHouseType;
  label: string;
  checked: boolean;
};
const HouseType = () => {
  const {
    setQuery,
    queries,
    routerAsPath
  } = useSearchParams();
  const {
    isMobile
  } = useDevice();
  const options: IOption[] = useMemo(() => [{
    name: 'villa',
    label: 'خانه ویلایی',
    checked: !!queries.villa
  }, {
    name: 'coastal',
    label: 'ساحلی',
    checked: !!queries.coastal
  }, {
    name: 'pool',
    label: 'استخردار',
    checked: !!queries.pool
  }, {
    name: 'cottage',
    label: 'کلبه',
    checked: !!queries.cottage
  }, {
    name: 'boomgardi',
    label: 'بوم‌گردی',
    checked: !!queries.boomgardi
  }, {
    name: 'apartment',
    label: 'آپارتمان',
    checked: !!queries.apartment
  }], [routerAsPath]);
  const [selectedFilters, setSelectedFilters] = useState<Partial<Record<IOption['name'], undefined | 1>>>(options.reduce((acc, curr) => ({
    ...acc,
    ...(curr.checked && {
      [curr.name]: 1
    })
  }), {}));
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const open = isDrawerOpen('HOUSE_TYPE');
  const closeRef = useRef<any>(null);
  const updateCheckStatus = (name: IOption['name']) => {
    const {
      [name]: updated,
      ...restSelected
    } = selectedFilters;
    setSelectedFilters({
      ...restSelected,
      ...(!updated && {
        [name]: 1
      })
    });
  };
  const handleClick = () => {
    if (open) {
      drawerClose();
    } else {
      drawerOpen('HOUSE_TYPE');
    }
  };
  const handleClose = () => {
    setSelectedFilters(options.reduce((acc, curr) => ({
      ...acc,
      ...(curr.checked && {
        [curr.name]: 1
      })
    }), {}));
    drawerClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };
  const checked = useMemo(() => options.some(item => !!queries?.[item.name]), [options, queries]);
  const submitData = () => {
    setQuery({
      villa: undefined,
      apartment: undefined,
      boomgardi: undefined,
      cottage: undefined,
      pool: undefined,
      coastal: undefined,
      ...selectedFilters
    });
  };
  const handleClean = e => {
    e.stopPropagation();
    setSelectedFilters({});
    setQuery({
      villa: undefined,
      apartment: undefined,
      boomgardi: undefined,
      cottage: undefined,
      pool: undefined,
      coastal: undefined
    });
  };
  const buttonText = useMemo(() => {
    if (!checked) return 'نوع اقامتگاه';
    return `${options.filter(item => !!queries?.[item.name]).map(item => item.label).join(' ، ')}`;
  }, [routerAsPath]);
  useEffect(() => {
    setSelectedFilters(options.reduce((acc, curr) => ({
      ...acc,
      ...(curr.checked && {
        [curr.name]: 1
      })
    }), {}));
  }, [open]);
  return <Box className={styles['filter-item-wrapper']} data-sentry-element="Box" data-sentry-component="HouseType" data-sentry-source-file="HouseType.tsx">
      <FilterChips type="secondary" checked={checked} handleClick={handleClick} handleClean={handleClean} label={buttonText} name="type_filter" endIcon id="house-type-chips" data-sentry-element="FilterChips" data-sentry-source-file="HouseType.tsx" />
      {!isMobile ? <Menu ref={closeRef} id="house-type" open={open} handleClose={drawerClose} className={styles['filter-item-container']} menuButtonId="house-type-chips" handleAction={() => {
      setSelectedFilters(options.reduce((acc, curr) => ({
        ...acc,
        ...(curr.checked && {
          [curr.name]: 1
        })
      }), {}));
    }}>
          <HouseTypeMobile updateCheckStatus={updateCheckStatus} options={options} handleClose={handleClose} submitData={submitData} handleClean={handleClean} hasHouseTypeFilter={checked} selectedFilters={selectedFilters} />
        </Menu> : <Drawer open={open} onClose={drawerClose}>
          <HouseTypeMobile updateCheckStatus={updateCheckStatus} options={options} handleClose={drawerClose} submitData={submitData} handleClean={handleClean} hasHouseTypeFilter={checked} selectedFilters={selectedFilters} />
        </Drawer>}
    </Box>;
};
export default HouseType;